import { useDocumentTitle } from "@/hooks/use-document-title";

export function CenterPanel({
  children,
  title,
  bare = false,
}: {
  children: React.ReactNode;
  title?: string;
  /** Render only the children: no scroll frame, no title, no tab title. Used
   *  when the page is shown inside another one, such as a section of Members. */
  bare?: boolean;
}) {
  useDocumentTitle(title ?? "", !bare);
  if (bare) return <>{children}</>;
  return (
    <div className="flex-1 overflow-y-auto">
      <div className="mx-auto max-w-5xl px-8 py-6">
        {title && <h1 className="text-2xl font-semibold text-text-primary mb-6">{title}</h1>}
        {children}
      </div>
    </div>
  );
}
